import * as React from 'react';
import { showAccountSettings } from 'state/actions';
import { getStoreState, storeDispatch } from 'state/Store';
import styled from 'styled-components';
import { isPro, styledWithProps } from 'utils';

const Title = styled.div`
  line-height: 18px;
  font-size: 10px;
  color: rgba(var(--controller-fg-rgb), 0.7);
  letter-spacing: 0.5px;
  margin-bottom: 5px;
  text-transform: uppercase;
`;

const Swatch = styledWithProps<{ color: string; selected: boolean }>()(
  styled.div
)`
  background-color: ${p => p.color};
  width: 16px;
  height: 16px;
  cursor: pointer;
  outline: none;
  border-radius: 3px;
  box-shadow: rgb(0 0 0 / 15%) 0px 0px 0px 1px inset${p =>
    p.selected ? `, ${p.color} 0 0 4px` : ''};
`;

const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-right: -9px;
  margin-bottom: -9px;

  & > * {
    margin-right: 9px;
    margin-bottom: 9px;
  }
`;

export const ColorSwatches: React.FC<{
  color: string;
  onChange: (color: string) => void;
}> = ({ color, onChange }) => {
  const user = getStoreState().app.user;
  if (!user || !isPro(user)) {
    return null;
  }

  const [boxShadow, setBoxShadow] = React.useState('none');

  React.useEffect(() => {
    // get shadow from class chrome-picker
    const picker = document.querySelector('.chrome-picker');
    if (picker) {
      setBoxShadow((picker as HTMLElement).style.boxShadow);
    }
  }, []);

  const colorsSet = new Set();

  const colorThemes = user.colorThemes;
  if (colorThemes) {
    colorThemes.forEach(t => {
      colorsSet.add(t.accent);
      colorsSet.add(t.background);
      colorsSet.add(t.foreground);
    });
  }

  const colors = Array.from(colorsSet) as string[];

  return (
    <div
      style={{
        width: 225,
        padding: '12px 16px',
        backgroundColor: 'white',
        borderBottomLeftRadius: 2,
        borderBottomRightRadius: 2,
        boxShadow
      }}
    >
      <Title>From your color themes</Title>
      {!colorThemes || colorThemes.length === 0 ? (
        <p style={{ margin: 0, fontSize: 12, lineHeight: '14px' }}>
          Create a{' '}
          <a onClick={() => storeDispatch(showAccountSettings())}>
            color theme
          </a>{' '}
          to access its colors here.
        </p>
      ) : (
        <Wrapper>
          {colors.map(c => (
            <Swatch
              color={c}
              selected={c.toLowerCase() === color.toLowerCase()}
              key={c}
              onClick={() => onChange(c)}
            />
          ))}
        </Wrapper>
      )}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/controller/components/ColorSwatches.tsx